import { IonInfiniteScroll, IonInfiniteScrollContent } from "@ionic/react";
import { AllieInfiniteScrollProps } from "./InfiniteScroll.types";

export const AllieInfiniteScroll: React.FC<AllieInfiniteScrollProps> = ({
  position = 'bottom',
  loadingSpinner = 'bubbles',
  threshold = '10%',
  loadingText,
  onFetch,
  ...props
}) => (
  <IonInfiniteScroll
    position={position}
    onIonInfinite={onFetch}
    threshold={threshold}
    {...props}
  >
    <IonInfiniteScrollContent
      loadingSpinner={loadingSpinner}
      loadingText={loadingText}
    />
  </IonInfiniteScroll>
);
